var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCs5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 29,
    viewBox: "0 0 60 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4545 0H3.625V0.65909V6.26136V22.0795H0V29H3.625H10.5455H18.4545H25.375H28.8352V22.0795H25.375V18.9205H35.4261V29H42.3466V17.9976L51.2131 29H59.2873L47.0227 13.8715L59.5653 0H51.7105L42.3466 10.0433V0H35.4261V12H25.375V6.26136V0H18.4545ZM18.4545 6.26136H10.5455L10.5455 22.0795H18.4545V6.26136Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCs5);
export default __webpack_public_path__ + "static/media/cs-5.d43abd197521d363936e89f24a0a11f3.svg";
export { ForwardRef as ReactComponent };